import angular from 'angular';

angular.module('cxTable').directive('cxScrollTable', [
  '$compile',
  function($compile) {
    return {
      restrict: 'A',
      priority: 50,
      terminal: true,
      compile: function(el) {
        el.removeAttr('cx-scroll-table'); //Remove own attribute to prevent endless compile loop
        //Inject infinite scroll attributes
        el.attr('infinite-scroll', 'table.getNextPage()');
        el.attr('infinite-scroll-disabled', 'table.retrieving');
        el.attr('cx-loading', 'table.showSpinner');
        var fn = $compile(el); //Recompile
        return function(scope) {
          fn(scope);
        };
      },
    };
  },
]);
